export default {
  labels: {
    order: '#order {{number}}',
    cancelled_order: '#order {{number}} canceled',
  },
};